module.exports = __webpack_public_path__ + "img/box-item-icon3.b91a8012.png";